import React, { useContext, useEffect } from 'react';
import store from '../../store';
// Custom components 
import AddWordsModal from '../../components/AddWordsModal';
import StoryCard from '../../components/StoryCard';
import AppHeader from '../../components/AppHeader';
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { fonts, storyContainer } from '../../assets/jss';

const useStyles = makeStyles((theme) => ({
    title: {
        margin: 5,
        ...fonts.secondary
    },
    wrapper: {
        ...storyContainer,
        gridTemplateRows: '11fr 1fr'        
    }
}));

function StoryPage() {
    const classes = useStyles();
    const { state, reducers } = useContext(store);
    const { currentStory } = state;

    useEffect(() => {
        if (currentStory.id !== undefined) {
            reducers.followStory(currentStory.id)
        }
        //eslint-disable-next-line
    }, [])

    return (
        <AppHeader>
            {currentStory !== undefined && currentStory.title !== undefined ?
                <div className={classes.wrapper}>
                    <StoryCard story={currentStory} />
                    <AddWordsModal story={currentStory} />
                </div> :
                <h2 className={classes.title}>Please select a story</h2>
            }
        </AppHeader>
    );
}

export default StoryPage;
